export default __webpack_public_path__ + "static/media/folder.7fbd09cd.svg";